<div class="accordion accordion-flush" id="Accordion-{{idAccordion_Referece}}" [style]="styleAccordion">
  <ng-content></ng-content>
</div>
